import { Component, Inject, OnInit } from '@angular/core';
import { getFormDirtyValues, IGroupContainer } from '../../models/group-edit-config';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DialogBoxResults } from '../../models/dialogDefaults';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'app-modal-editor',
  templateUrl: './modal-editor.component.html',
  styleUrls: ['./modal-editor.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('in', style({ transform: 'translateY(0)' })),
      transition('void => *', [
        style({ transform: 'translateY(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateY(100%)' }))
      ])
    ])
  ]
})
export class ModalEditorComponent implements OnInit {
    config: IGroupContainer;
    completeDisabled = false;

    financialYearEnd: any;
    nextProcessingDate: any;
    region = '';
        
    constructor(@Inject(MAT_DIALOG_DATA)private data: IGroupContainer,
        public dialogRef: MatDialogRef<ModalEditorComponent>,
        private dlg: DialogService) { 
        this.config = this.data;
    }

    ngOnInit(): void {
        if(this.config.company){
            this.financialYearEnd = this.config.company.financialYearEnd;
            this.nextProcessingDate = this.config.company.nextProcessingDate;
            this.region = this.config.company.region;
        }
    }

    async completedModalAction(){
        this.completeDisabled = true;
        await this.config.completeAction(this.dialogRef);
        this.completeDisabled = false;
    }

    async cancelledModalEdit(){
        const data = {};
        getFormDirtyValues(this.config.form, data);
        if(Object.keys(data).length > 0) {
            const dbsRes = await this.dlg.showYesNo("Close editor without saving", "You have unsaved changes in the editor window.  Are you sure you want to close without saving?");
            if(dbsRes === DialogBoxResults.Yes){
                this.config.cancelAction(this.dialogRef);
            }
        }else{
            this.config.cancelAction(this.dialogRef);
        }        
    }

    debugModalData(){
        if(this.config.debugAction){
            this.config.debugAction(this.dialogRef);
        }else{
            console.log('Modal Editor Debug Info.  Form control status:', this.config.form);

        }
    };

}
